import api from "@/config/api";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import type {
  RentalSummaryDTO,
  RentalSearchItemDTO,
  CommissionSummaryItemDTO,
} from "../types/dashboard.types";

interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
}

export const dashboardService = {
  getRentalSummary: async (
    startDate: string,
    endDate: string,
  ): Promise<RentalSummaryDTO> => {
    const { data } = await api.get<RentalSummaryDTO>(
      API_ENDPOINTS.RENTALS.SUMMARY,
      { params: { startDate, endDate } },
    );
    return data;
  },

  getRentals: async (
    startDate: string,
    endDate: string,
  ): Promise<RentalSearchItemDTO[]> => {
    const { data } = await api.get<PageResponse<RentalSearchItemDTO>>(
      API_ENDPOINTS.RENTALS.SEARCH,
      {
        params: {
          startDate,
          endDate,
          page: 0,
          size: 500,
          sortBy: "rentedAt",
          sortDirection: "ASC",
        },
      },
    );
    return data.content;
  },

  getCommissionSummary: async (
    startDate: string,
    endDate: string,
  ): Promise<CommissionSummaryItemDTO[]> => {
    const { data } = await api.get<CommissionSummaryItemDTO[]>(
      API_ENDPOINTS.SELLER_COMMISSIONS.SUMMARY,
      { params: { startDate, endDate } },
    );
    return data;
  },

  // Retorna onStreetCount e incompleteCount sem filtro de data — estado atual de TODOS os aluguéis
  getCurrentActiveSummary: async (): Promise<RentalSummaryDTO> => {
    const { data } = await api.get<RentalSummaryDTO>(
      API_ENDPOINTS.RENTALS.SUMMARY,
    );
    return data;
  },

  // Busca todos os aluguéis ON_STREET para calcular atrasados via expectedInAt
  getAllOnStreetRentals: async (): Promise<RentalSearchItemDTO[]> => {
    const { data } = await api.get<PageResponse<RentalSearchItemDTO>>(
      API_ENDPOINTS.RENTALS.SEARCH,
      { params: { statuses: ["ON_STREET"], page: 0, size: 500 } },
    );
    return data.content;
  },

  getMaintenanceCount: async (isAdmin: boolean): Promise<number> => {
    const endpoint = isAdmin
      ? API_ENDPOINTS.MAINTENANCES_ADMIN.SEARCH
      : API_ENDPOINTS.MAINTENANCES.SEARCH;
    const { data } = await api.get<{ totalInMaintenance: number }>(endpoint, {
      params: { active: true, page: 0, size: 1 },
    });
    return data.totalInMaintenance;
  },
};
